import React from 'react';
import { Outlet } from 'react-router-dom';
import SignHeader from '../components/FlowComponents/SignHeader/SignHeader';
import Footer from '../landing/Footer/Footer';

const MainLayout = () => {
    return (
        <>
            <SignHeader />
            <Outlet />
            <Footer />
        </>
    );
};

export default MainLayout;